import { defineNuxtRouteMiddleware, trackRefererData } from '#imports'

// Its response sets the affiliate attribution cookies, so it must settle before the page renders.
export default defineNuxtRouteMiddleware(async (to) => {
    if (import.meta.client) return

    await trackRefererData(to)
})
